// extracted by mini-css-extract-plugin
export default {"title_style":"SingleDeviceBoard_title_style__BMx-r","wrapperPadding":"SingleDeviceBoard_wrapperPadding__zqgTI"};